import { Job } from "~/components/build/Show/lib/types";
import Notice from "~/components/shared/Notice";

interface Props {
  job: Job;
}

export const StackErrored = ({ job }: Props) => {
  if (job.type !== "script") {
    return null;
  }
  if (!job.stackErrored) {
    return null;
  }

  const message = "This job has been marked as failed by agent stack.";
  const type = job.softFailed ? "warning" : "error";

  const stackErrorDetail = (
    <details>
      <summary>
        {job.stackErrorDetail?.substring(0, 100)}
        {job.stackErrorDetail && job.stackErrorDetail.length > 100 ? "..." : ""}
      </summary>
      <pre className="overflow-x-auto whitespace-pre-wrap break-words rounded bg-gray-100 p-3 text-sm">
        <code className="text-gray-800">{job.stackErrorDetail}</code>
      </pre>
    </details>
  );

  const cannedMessage = (
    <>
      Check the <strong>Timeline</strong> tab for more information.
    </>
  );

  return (
    <Notice title={message} noticeType={type} icon="heroicons/16/solid/exclamation-triangle">
      <p>{job.stackErrorDetail ? stackErrorDetail : cannedMessage}</p>
    </Notice>
  );
};
